import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { NewsRightSideBarInterface } from './news-right-side-bar.interface';
import moment from 'moment-timezone';
import 'moment-timezone';
import { ArticleStatusEnum } from '../../enums/ArticleStatus.enum';
import { PreferencesModel } from '../../../../Core/Users/models/preferences.model';
import { TimeModel } from '../../../../Common/Forms/models/time.model';
import { deliverySchedulingTypesEnum } from '../../../../Common/Forms/enums/delivery-scheduling-types.enum';
import { validateEmail } from '../../../../Common/Misc/helpers/formatting/email.helper';
import { MessageModel } from '../../../../Common/Misc/models/message.model';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { DistributionRegionsEnum } from '../../enums/DistributionRegions.enum';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';

const newsRightSideBarComponent = {
    publishNow: 'Publish now',
    publishLater: 'Publish later',
    missingDateInformation: 'Missing date information',
    missingHourInformation: 'Missing hour information',
    missingMinuteInformation: 'Missing minute information',
    industryRequired: 'Industry required',
    allowXMinutes: 'Please allow at least {{editingDelay}} minutes for content review.',
    pressReleaseXMinuteMinimum: 'Due to the editorial review process, \
                                 Press Releases must be submitted at least \
                                 {{editingDelay}} minutes before the time of release. \
                                 Press Releases may not be retracted within 60 minutes \
                                 of the scheduled release time.',
    newswireIndustryInfo: 'The industry selection allows for targeted release distribution. \
                            The distribution network for this release will be focused to the \
                            industry that is chosen.',
    contactEmailErrorMessage: 'Invalid email format.'
};

@Component({
    selector: 'agpr-news-right-side-bar',
    templateUrl: './news-right-side-bar.component.html',
    styleUrls: ['./news-right-side-bar.component.scss'],
    standalone: false
})
export class NewsRightSideBarComponent implements OnInit, OnChanges {
    public readonly buttonTypes = ButtonTypesEnum;
    // TODO: Separate inputs and outputs for better readability
    @Input() preferences: PreferencesModel;
    @Input() localization = newsRightSideBarComponent;
    @Input() public hideTagFeature: boolean = false;
    @Input() public rightSideBarInterface: NewsRightSideBarInterface;
    @Input() public showLogoButton: boolean = false;
    @Input() public showImageButton: boolean = false;
    @Input() public aboutUsButtonDisabled: boolean = false;
    @Input() public aboutUsButton: boolean = false;
    @Input() public contactButton: boolean = false;
    @Input() public linkButton: boolean = false;
    @Input() public statusId: ArticleStatusEnum;
    @Input() public showPublishLater: boolean = false;
    @Input() public showPublishErrors: boolean = false;
    @Input() public showDraftErrors: boolean = false;
    @Input() public industryList: DropdownOptionModel[] = [];
    @Input() public reservedUrl: string = null;
    @Input() public reportUrl: string = null;
    @Input() publishedDate: Date;
    @Input() lastModifiedDate: Date;
    @Input() regions: DistributionRegionsEnum[] = [];
    @Output() regionsChange = new EventEmitter<DistributionRegionsEnum[]>();

    @Input() public id: number;
    @Input() public isLoader: boolean = false;
    @Input() public createdBy: string;
    @Input() public createdDate: Date;
    @Input() public remainingUSReleases: number = -1;
    @Input() public remainingUKReleases: number = -1;
    @Input() public remainingCanadaReleases: number = -1;
    @Input() public remainingNorthAmericaReleases: number = -1;
    @Input() public preferredMethodList: DropdownOptionModel[] = [];
    @Input() public scheduledDate: Date = null;
    @Output() scheduledDateChange: EventEmitter<Date> = new EventEmitter<Date>();
    @Input() scheduledTime: TimeModel = null;
    @Output() scheduledTimeChange: EventEmitter<TimeModel> = new EventEmitter<TimeModel>();
    @Input() schedulingType: deliverySchedulingTypesEnum;
    @Output() schedulingTypeChange: EventEmitter<deliverySchedulingTypesEnum> = new EventEmitter<deliverySchedulingTypesEnum>();
    @Input() industryId: number;
    @Output() industryIdChange = new EventEmitter<number>() ;
    @Input() metaData: string;
    @Output() metaDataChange = new EventEmitter<string>() ;
    @Input() contactName: string;
    @Output() contactNameChange = new EventEmitter<string>() ;
    @Input() contactPhone: string;
    @Output() contactPhoneChange = new EventEmitter<string>() ;
    @Input() contactEmail: string;
    @Output() contactEmailChange = new EventEmitter<string>() ;
    @Input() preferredMethodId: number;
    @Output() preferredMethodIdChange = new EventEmitter<number>();
    @Input() notesForEditor: string;
    @Output() notesForEditorChange = new EventEmitter<string>();
    @Input() timeZone: string;
    @Output() timeZoneChange = new EventEmitter<string>() ;
    @Output() modelChange: EventEmitter<void> = new EventEmitter<void>();
    @Input() minDate: Date = null;
    @Input() editingDelay: number;

    @Input() remainingTextContents: number;
    @Input() remainingImageContents: number;
    @Input() remainingVideoContents: number;
    public statusEnum = ArticleStatusEnum;
    public validContactEmail: boolean;
    public selectedIndustry: DropdownOptionModel;
    public selectedContactMethod: DropdownOptionModel;
    public distributionRegionsEnum = DistributionRegionsEnum;

    ngOnInit() {
        if (this.industryId) {
            this.selectedIndustry = this.industryList.find(option => option.value === this.industryId);
        } else {
            this.selectedIndustry = null;
        }
        if (this.preferredMethodId) {
            this.selectedContactMethod = this.preferredMethodList.find(option => option.value === this.preferredMethodId);
        } else {
            this.selectedContactMethod = null;
        }
    }

    ngOnChanges() {
        if (this.industryId) {
            this.selectedIndustry = this.industryList.find(option => option.value === this.industryId);
        } else {
            this.selectedIndustry = null;
        }
        if (this.preferredMethodId) {
            this.selectedContactMethod = this.preferredMethodList.find(option => option.value === this.preferredMethodId);
        } else {
            this.selectedContactMethod = null;
        }
    }

    getFormattedTime(date: Date, timezone: string): string {
        let momentDate = moment(date);
        if (timezone) {
            momentDate = momentDate.tz(timezone);
        } else {
            momentDate = momentDate.tz('UTC');
        }
        return momentDate.format('MMM, DD YYYY hh:mm A z');
    }

    public timezoneSelected(): void {
        this.timeZoneChange.emit(this.timeZone);
        this.modelChange.emit();
    }

    public preferredMethodSelected(): void {
        this.preferredMethodId = this.selectedContactMethod?.value;
        this.preferredMethodIdChange.emit(this.preferredMethodId);
        this.modelChange.emit();
    }

    public notesForEditorChanged() {
        this.notesForEditorChange.emit(this.notesForEditor);
        this.modelChange.emit();
    }

    public metaDataChanged(): void {
        this.metaDataChange.emit(this.metaData);
        this.modelChange.emit();
    }

    public contactNameChanged(): void {
        this.contactNameChange.emit(this.contactName);
        this.modelChange.emit();
    }

    public contactPhoneChanged(): void {
        this.contactPhoneChange.emit(this.contactPhone);
        this.modelChange.emit();
    }

    public contactEmailChanged(): void {
        this.contactEmailChange.emit(this.contactEmail);
        this.validContactEmail = validateEmail(this.contactEmail);
        this.modelChange.emit();
    }

    public industrySelected(): void {
        this.industryId = this.selectedIndustry?.value;
        this.industryIdChange.emit(this.industryId);
        this.modelChange.emit();
    }

    public distributionRegionChange(): void {
        this.regionsChange.emit(this.regions);
        this.modelChange.emit();
    }

    public getTagNameById(tagId): string {
        return this.rightSideBarInterface.getTagNameById(tagId);
    }

    public removeTag(tagId: number) {
        return this.rightSideBarInterface.removeTag(tagId);
    }

    public displayTagDialogBox() {
        this.rightSideBarInterface.displayTagDialogBox();
    }

    public imageClick(type: string): void {
        this.rightSideBarInterface.imageClick(type);
    }
    public textClick(): void {
        this.rightSideBarInterface.textClick();
    }
    public videoClick(): void {
        this.rightSideBarInterface.videoClick();
    }

    public toggleAboutUs(): void {
        this.rightSideBarInterface.toggleAboutUs();
    }
    public toggleContact(): void {
        this.rightSideBarInterface.toggleContact();
    }

    public toggleLink(): void {
        this.rightSideBarInterface.toggleLink();
    }

    public getPublishNowStatus(status: boolean): void {
        this.rightSideBarInterface.getPublishNowStatus(status);
    }

    public getPublishLaterStatus(status: boolean): void {
        this.rightSideBarInterface.getPublishLaterStatus(status);
    }

    public getPublishDate(publishDate: number): void {
        this.rightSideBarInterface.getPublishDate(publishDate);
    }

    public scheduledDateSelected(newDate: Date): void {
        this.scheduledDateChange.emit(newDate);
        this.modelChange.emit();
    }

    public schedulingTypeSelected(newSchedulingType: deliverySchedulingTypesEnum): void {
        this.schedulingTypeChange.emit(newSchedulingType);
    }

    /**
     * Gets an array of errors related to the delivery scheduler based on
     * publish status, the date field, and time fields
    */
    public getDeliveryDateErrorMessages(): MessageModel[] {
        const errorMessages: MessageModel[] = [];
        const hasDate: boolean = this.scheduledDate !== null && this.scheduledDate !== undefined;
        const hasHour: boolean = this.scheduledTime && this.scheduledTime.hour !== null && this.scheduledTime.hour !== undefined;
        const hasMinute: boolean = this.scheduledTime && this.scheduledTime.minute !== null && this.scheduledTime.minute !== undefined;

        const dateMissingError: MessageModel = {
            severity: messageSeverityEnum.error,
            summary: this.localization.missingDateInformation
        };

        const hourMissingError: MessageModel = {
            severity: messageSeverityEnum.error,
            summary: this.localization.missingHourInformation
        };

        const minuteMissingError: MessageModel = {
            severity: messageSeverityEnum.error,
            summary: this.localization.missingMinuteInformation
        };

        if (this.showPublishErrors) {
            if (!hasDate) {
                errorMessages.push(dateMissingError);
            }

            if (!hasHour) {
                errorMessages.push(hourMissingError);
            }

            if (!hasMinute) {
                errorMessages.push(minuteMissingError);
            }
        }

        return errorMessages;
    }

    /**
     * Gets the the provided string with the editing delay dynamically set
    */
    public getLocalizedStringWithEditingDelay(localizedString: string): string {

        let editingDelay: string;
        let updatedLocalization: string = null;
        const hasEditingDelay: boolean = this.editingDelay !== null && this.editingDelay !== undefined;
        const hasLocalizedString: boolean = localizedString && typeof localizedString === 'string';

        if (hasLocalizedString && hasEditingDelay) {

            editingDelay = this.editingDelay.toString();
            updatedLocalization = localizedString.replace('{{editingDelay}}', editingDelay);

        }

        return updatedLocalization;

    }

    public emitScheduledTimeChange(newTime: TimeModel): void {

        this.scheduledTimeChange.emit(newTime);

    }

    /**
     * Returns a boolean stating whether the industry ID is set or not
    */
    public isIndustryIDSet(): boolean {

        const isIndustryIDSet: boolean = this.industryId !== null && this.industryId !== undefined;

        return isIndustryIDSet;

    }

    openTab(url: string): void {
        window.open(url);
    }
}
